import React from "react";
import PhoneInput from "react-phone-number-input";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import "react-phone-number-input/style.css";
import { Box, IconButton } from "@mui/material";

// export const PhoneInputFormField = ({ field, form, label, isRequired, ...props }) => {
//     const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

//     return (
//         <FormControl fullWidth error={!!errorText}>
//             {label && (
//                 <Box sx={{ mb: 2 }}>
//                     <InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
//                         <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
//                             {label}
//                             {isRequired && (
//                                 <Typography variant="h6" color="error" component="span">
//                                     {" *"}
//                                 </Typography>
//                             )}
//                         </Typography>
//                     </InputLabel>
//                 </Box>
//             )}

//             {/* Phone Input */}
//             <PhoneInput
//                 international
//                 defaultCountry="IN"
//                 value={field.value ?? null}  // Ensuring value is always string or null
//                 countryCallingCodeEditable={false}
//                 onChange={(value) => form.setFieldValue(field.name, value ?? "")} // Ensuring null values are handled
//                 onBlur={() => {
//                     form.setFieldTouched(field.name, true, true); 
//                 }}
//                 {...props}

//                 style={{
//                     backgroundColor: "#F7FAFF",
//                     border: "1px solid #4169E1",
//                     padding: "14px 10px",
//                     borderRadius: "5px",
//                     fontSize: "15px",

//                 }}
//             />
//             {errorText && <Typography variant="h6" fontSize={"10px"} color="red">{errorText}</Typography>}
//         </FormControl>
//     );
// };

export const PhoneInputFormField = ({
  field,
  form,
  label,
  isRequired,
  startIcon,
  endIcon,
  OnButtonClick,
  ...props
}) => {
  const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);

  return (
    <FormControl fullWidth error={!!errorText}>
      {label && (
        <Box sx={{ mb: 2 }}>
          <InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
            <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
              {label}
              {isRequired && (
                <Typography variant="h6" color="error" component="span">
                  {" *"}
                </Typography>
              )}
            </Typography>
          </InputLabel>
        </Box>
      )}

      {/* Input container with optional icons */}
      <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
       

        <PhoneInput
          international
          defaultCountry="IN"
          value={field.value ?? null}
          countryCallingCodeEditable={false}
          onChange={(value) => form.setFieldValue(field.name, value ?? "")}
          onBlur={() => {
            form.setFieldTouched(field.name, true, true);
          }}
          {...props}
          style={{
            backgroundColor: "#F7FAFF",
            border: "1px solid #4169E1",
            padding: "14px 10px",
            paddingLeft: startIcon ? "40px" : "10px",
            paddingRight: endIcon ? "40px" : "10px",
            borderRadius: "5px",
            fontSize: "15px",
            width: "100%",
          }}
        />

        {endIcon && (
          <IconButton sx={{ position: "absolute", right: 10, top:2,bottom:2, zIndex: 1, color: "green" , bgcolor:"#D5E0FF",borderRadius:1 }} onClick={() => OnButtonClick?.(field.value)}
>
            {endIcon}
          </IconButton>
        )}
      </Box>

      {errorText && (
        <Typography variant="h6" fontSize={"10px"} color="red">
          {errorText}
        </Typography>
      )}
    </FormControl>
  );
};










